<template>
  <div>
    <div class="container" v-if="qrcode">
      <img class="img" :src="qrcode" />
    </div>
    <div class="tips">
      请将二维码放置在柜机屏幕下方<br />红外探头<span class="distance">5cm</span>处扫描
    </div>
    <div class="songhuo-container">
      <div class="songhuo" @click="songhuo()" v-if="
        item.status == 0 && item.worksite && item.worksite.paotuiAble
      ">
        送件上门
      </div>
    </div>
    <div class="line">校圆通<br />粤ICP备18078387号</div>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";

export default {
  data() {
    return {
      encodeToken: "",
      qrcode: null,
      item: {},
      userInfo: {},
    };
  },
  created() {
    let _id = this.$route.params.expressId;
    this.encodeToken = this.$route.params.token;
    let token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + token;

    let loading = weui.loading("取件码加载ing...", {
      className: "custom-classname",
    });

    // 根据ID获取qrcode
    axios
      .get("/api/expressTosend/getById/" + _id)
      .then((res) => {
        setTimeout(() => {
          loading.hide();
        }, 500);
        if (res.data.success) {
          this.item = res.data.data;
          // 人工区取件
          if (this.item.type == 1) {
            this.$router.push("/expressTotakeList/ing/" + this.encodeToken);
            return;
          }
          this.qrcode = "data:image/png;base64," + this.item.qrimgBase64;
        }
      })
      .catch((err) => {
        setTimeout(() => {
          loading.hide();
        }, 500);
      });

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfoForTotakeList")
      .then((response) => {
        this.userInfo = response.data.data;
      })
      .catch((error) => {
        this.haveData = false;
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    songhuo() {
      this.$router.push(
        "/doorService/" + this.item._id + "/" + this.encodeToken
      );
    },
  },
};
</script>

<style scoped>
.proxy {
  background-color: red;
  margin: 15px;
  text-align: center;
  padding: 15px;
  font-size: 16px;
  color: #fff;
}

.container {
  display: flex;
}

.img {
  margin: 50px auto 0px auto;
  width: 60%;
  justify-content: center;
  align-items: center;
}

.tips {
  text-align: center;
  font-size: 20px;
  margin: 15px;
}

.distance {
  color: red;
  font-weight: bold;
  margin-left: 5px;
  margin-right: 5px;
}

.line {
  position: fixed;
  text-align: center;
  bottom: 15px;
  width: 100%;
}

.songhuo-container {
  margin: 30px;
  display: flex;
  align-content: center;
}

.songhuo {
  flex: 1;
  background-color: orangered;
  color: white;
  text-align: center;
  font-size: 18px;
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/ExpressQrcode.vue